import request from 'api/requestUtils'
import type { paths } from '@luxuryescapes/contract-cart'

type PromotionRequest = Omit<paths['/api/carts/multi-carts/{multiCartId}/items']['patch']['requestBody']['content']['application/json'], 'brand'>
type PromotionResponse = paths['/api/carts/multi-carts/{multiCartId}/items']['patch']['responses']['200']['content']['application/json']

export async function promoteMultiCartItems(cartId: string, itemIds: Array<string>): Promise<void> {
  if (!itemIds.length) return
  await request.patch<PromotionResponse, PromotionRequest>(`/api/carts/multi-carts/${cartId}/items`, {
    itemIds,
    update: { intent: 'deliberate' },
  }, { credentials: 'include' })
}
